import { Editor, Transforms } from "slate";
import { jsx } from "slate-hyperscript";

const ELEMENT_TAGS: any = {
  A: (el: HTMLLinkElement) => ({ type: "link", href: el.getAttribute("href") }),
  BLOCKQUOTE: () => ({ type: "block-quote" }),
  H1: () => ({ type: "heading", level: 1 }),
  H2: () => ({ type: "heading", level: 2 }),
  H3: () => ({ type: "heading", level: 3 }),
  IMG: (el: HTMLImageElement) => ({
    type: "image",
    desktopUrl: el.getAttribute("src"),
    mobileUrl: el.getAttribute("src"),
    rawUrl: el.getAttribute("src"),
  }),
  LI: () => ({ type: "list-item" }),
  OL: () => ({ type: "ordered-list" }),
  P: () => ({ type: "paragraph" }),
  PRE: () => ({ type: "code-block" }),
  UL: () => ({ type: "unordered-list" }),
};

const TEXT_TAGS: any = {
  EM: () => ({ italic: true }),
  I: () => ({ italic: true }),
  STRONG: () => ({ bold: true }),
  U: () => ({ underline: true }),
};

const shouldIgnoreParagraph = (childNodes: NodeListOf<ChildNode>): boolean => {
  let ignoreParagraph = false;
  childNodes.forEach((node: ChildNode) => {
    if (node.nodeName === "IMG") ignoreParagraph = true;
  });
  return ignoreParagraph;
};

const deserialize = (el: ChildNode): any => {
  if (el.nodeType === 3) {
    return el.textContent;
  }
  if (el.nodeType !== 1) {
    return null;
  }
  if (el.nodeName === "P" && shouldIgnoreParagraph(el.childNodes)) {
    return Array.from(el.childNodes).map(deserialize).flat();
  }

  if (el.nodeName === "BR") {
    return "\n";
  }

  const { nodeName } = el;
  let parent = el;

  if (
    nodeName === "PRE" &&
    el.childNodes[0] &&
    el.childNodes[0].nodeName === "CODE"
  ) {
    parent = el.childNodes[0];
  }
  let children = Array.from(parent.childNodes).map(deserialize).flat();

  if (children.length === 0) {
    children = [{ text: "" }];
  }

  if (el.nodeName === "BODY") {
    return jsx("fragment", {}, children);
  }

  if (ELEMENT_TAGS[nodeName]) {
    const attrs = ELEMENT_TAGS[nodeName](el);
    return jsx("element", attrs, children);
  }

  if (TEXT_TAGS[nodeName]) {
    const attrs = TEXT_TAGS[nodeName](el);
    return children.map((child) => jsx("text", attrs, child));
  }

  return children;
};
export const withPaste = (editor: Editor) => {
  editor.insertData = (data) => {
    const { insertData } = editor;
    const html = data.getData("text/html");

    if (html) {
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const fragment = deserialize(parsed.body);
      Transforms.insertFragment(editor, fragment);
      return;
    }

    insertData(data);
  };

  return editor;
};
